import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { DashboardProjectionSettingsModel } from './dashboard-projection-content.models';

@Injectable({
    providedIn: 'root'
})
export class DashboardProjectionService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    public async loadCustomProjectionSettings() {
        const response = await this.cvApiService.get<DashboardProjectionSettingsModel>("/api/v2/dashboard-projection/custom-settings");
        if (response.status_code === 200)
            return response.data;
        throw response;
    }

    public async saveCustomProjectionSettings(customSettings: DashboardProjectionSettingsModel) {
        const response = await this.cvApiService.post("/api/v2/dashboard-projection/custom-settings", customSettings);
        if (response.status_code === 200)
            return response.data;
        throw response;
    }
}
